import DataTable from "react-data-table-component";
import Checkbox from "@material-ui/core/Checkbox";
import SortIcon from "@material-ui/icons/ArrowDownward";
// import "./styles.css";
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import React, { useState, useMemo, useCallback, useEffect, Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import SavedSearch from '../../services/savedsearch';
import SavedSearchModal from '../../shared/Modal/SavedSearchModal';
import styled from "styled-components";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  loginDiv: {
    border: '2px solid #bfb4b4',
    borderRadius: '6px',
    padding: '20px',
    height: '100%'
  },
  forgotLink: {
    marginTop: '10px',
    a: {
      color: '#008EC5'
    }
  },
  textHeading: {
    fontWeight: "700 !important",
    color: "#5A6868",
    fontSize: 'larger'
    // marginBottom: "400px",

  },
  buttonStyle: {
    float: 'right',
    textTransform: 'none',
    margin: '4px',
    backgroundColor: '##DB862D !important',
    border: '1px solid ##DB862D !important',
    marginTop: '4px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    }

  },
  footerDiv: {
    padding: '0 30px',
    marginTop: '-20px',
    marginRight: '65px',
  },
  buttonStyleCancel: {
    float: 'right',
    textTransform: 'none',
    margin: '4px',
    color: 'white',
    backgroundColor: '#008EC5 !important',
    border: '1px solid #1F4E79 !important',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    }

  },
  columnPadding: {
    // paddingTop: '20px',
    // paddingLeft: '20px'
    marginTop: '-30px',
    marginRight: '82px',
  },
  columnPaddings: {
    paddingTop: '5px',
    paddingLeft: '877px'
  },
  line: {
    borderBottom: '1px solid #E7E4E4',
    paddingBottom: '20px',
  },
  columnPad: {
    padding: '80px',
    marginTop: '-30px',
  }
}));
const customStyles = {
  headRow: {
      style: {
          backgroundColor: '#white', // Set to transparent or remove this property
      },
  },
  rows: {
    style: {
      minHeight: '50px', // override the row height
    }
  },
  headCells: {
      style: {
          paddingLeft: '8px', // override the cell padding for head cells
          paddingRight: '8px',
          // borderLeft:'1px solid #0606061f',
          borderRight: '1px solid #0606061f',
          '&:first-child': {
              borderLeft: '0',
              borderRight: '1px solid #0606061f'
          },
          '&:last-child': {
              borderRight: '0',
              paddingLeft: '20px',
          },
          fontWeight: 'bold',
          color: '#4a5050',
      },
  },
  cells: {
      style: {
          paddingLeft: '8px', // override the cell padding for data cells
          paddingRight: '8px',
          // borderLeft:'1px solid #0606061f',
          borderRight: '1px solid #0606061f',
          borderBottom: '1px solid #0606061f',
          '&:first-child': {
              borderLeft: '0',
              borderRight: '1px solid #0606061f'
          },
          '&:last-child': {
              borderRight: '0',
              paddingLeft: '20px',
          },
          '&:second-child': {
              borderLeft: '0',
          },

          display: 'grid',
      },

  },
};

const customStylesDark = {
  headRow: {
      style: {
          backgroundColor: '#292929', // Set to transparent or remove this property
      },
  },
  rows: {
    style: {
      minHeight: '50px', // override the row height
      backgroundColor: '#292929',
      color: 'white',
    },
  },
  headCells: {
      style: {
        paddingLeft: '8px', // Padding for head cells
        paddingRight: '8px',
        borderBottom: '1px solid #777', // Add border bottom to head cells
        'div:hover': { // Specific hover style for div within head cell
          color: '#ffffff', // Hover text color
        },
        '&:not(:last-child)': {
          borderRight: '1px solid #777', // Add border right to all but the last head cell
        },
        '&:first-child': {
          borderLeft: '0',
          maxWidth: '160px',
        },
        '&:nth-child(2)': {
          maxWidth: '110px',
        },
        '&:nth-child(5), &:nth-child(4)': {
          maxWidth: '200px',
        },
        fontSize: '14px',
        fontWeight: '700',
        color: '#777777',
        justifyContent: 'start !important',
        '&:focus': {
        outline: 'none', // Remove focus outline
      },
      '&:active': {
        color: '#777777', // Maintain the default color when active
        backgroundColor: '#292929', // Maintain background color on click
      },
      }
    },
    cells: {
      style: {
        paddingLeft: '8px', // Padding for data cells
        paddingRight: '8px',
        borderBottom: '1px solid #777', // Add border bottom to data cells
        '&:not(:last-child)': {
          borderRight: '1px solid #777', // Add border right to all but the last data cell
        },
        '&:first-child': {
          borderLeft: '0',
        },
        display: 'grid',
        justifyContent: 'start !important',
      }
    },
  tableWrapper: {
      style: {
          backgroundColor: 'black',
          borderRight: '0', // Remove any right border
          marginRight: '0',
          paddingRight: '0', // Ensure no extra padding
          overflow: 'hidden', // Prevent scroll or overflow issue
      },
  },
  noData: {
    style: {
        backgroundColor: '#292929', // Dark mode background for no data message
        color: 'white', // Text color for "No items were found"
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
  },
};
const conditionalRowStyles = [
  {
    when: row => row.director < 300,
    style: {
      backgroundColor: 'green',
      color: 'white',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
  // You can also pass a callback to style for additional customization
  {
    when: row => row.director < 300,
    style: row => ({
      backgroundColor: row.isSpecia ? 'pink' : 'inerit',
    }),
  },
];

const columns = [
  {
    name: "Type",
    selector: "typeContent",
    // sortable: true,
    width: '20%'
  },
  {
    name: "Name",
    selector: "nameContent",
    defaultSortAsc: true,
    left: true,
    width: '75.3%',
    // style:{
    //   marginLeft: '40px'
    // }
  }
];


const isIndeterminate = indeterminate => indeterminate;
const selectableRowsComponentProps = { indeterminate: isIndeterminate };
function homePage() {

}
function SearchResults() {
  const classes = useStyles();
  const [thing, setThing] = useState([]);
  const handleAction = value => setThing(value);
  const [modalShow, setModalShow] = React.useState(false);
  const [checkTemplate, setCheckTemplate] = React.useState(false);
  const [checkValIn, setCheckValIn] = React.useState(false);

  const [errorMessage, setErrorMessage] = useState('');
  const [checkValue, setCheckValue] = React.useState(false);

  const history = useHistory();

  const [searchFormsData, setSearchFormsData] = useState([]);
  const [selectedTemplateData, setSelectedTemplateData] = useState(false);
  // unlike class methods updateState will be re-created on each render pass, therefore, make sure that callbacks passed to onSelectedRowsChange are memoized using useCallback
  const updateState = useCallback(state => setThing(state));
  const toggle = useSelector(state => state.setToggle.toggle);
  const userInfo = useSelector(state => state.setUserInfo);
  function updateVal(state) {
    setThing(state);
    if (state.selectedCount >= 1) {
      setCheckValue(true);
    }
    else if (state.selectedCount == 1) {
      setCheckValue(true);
    }
    else {
      setCheckValue(false);
    }

  }
  // useEffect(() => {
  //   async function fetchMyAPI() {
  //     const result = await SavedSearch.getSavedSearchData();
  //     if(result.response_content && result.response_content.templates)
  //     {
  //       const dta = await result.response_content.templates;
  //       //  setSearchFormsData(dta);
  //     }
  //     // (result.response_content && result.response_content.template) ? setSearchFormsData(result.response_content.template) : "" ;
  //   }
  //   fetchMyAPI();
  //   // setThing([]) getSavedSearchData
  //   // document.title = `You clicked ${count} times`;
  // });

  function chechBoxFunction() {
    const TableContainer = styled.div`
      table {
          margin-left: 70px;
          margin-top: 37px;
          width:80%;
        tr {
          border-bottom: 2px solid #dee2e6;
          :first-child {
            border-top: 2px solid #dee2e6;
          }
        }
        td {
          color: 'black';
          :first-child {
            border-right: 2px solid #dee2e6;
            width: 180px;
          }
          :last-child {
            padding-left: 20px;

          }
        }
      }
    `;
  }
  useEffect(() => {
    (async () => {
      document.title = 'GenomeQuest - Saved Search Forms'
      // const result = await SavedSearch.getSavedSearchData();
      // if(result && result.response_content && result.response_content.templates)
      // {
      //   const dta = await result.response_content.templates;
      //   constrainTemplateData(dta);
      //    setSearchFormsData(dta);

      // }
      getSavedTemplateData();
    })()
  }, []);

  async function getSavedTemplateData() {
    const result = await SavedSearch.getSavedSearchData(history);
    if (result && result.response_content && result.response_content.templates) {
      const dta = await result.response_content.templates;
      constrainTemplateData(dta);
      setSearchFormsData(dta);


    }
  }
  async function constrainTemplateData(savedData) {

    savedData.map(datas => {
      if (datas.type == 'GqWfVMIpSearch_launch') {
        datas.typeContent = 'Variation';
        datas.nameContent = <Fragment>
          <Link to={"/ipseqvariation/template/" + encodeURIComponent(datas.name)} >{datas.name}</Link>
        </Fragment>

      }
      else if (datas.type == 'GqWfIpSearch_launch') {
        datas.typeContent = 'IP Sequence';
        datas.nameContent = <Fragment>
          <Link to={"/ipseqsearch/template/" + encodeURIComponent(datas.name)} >{datas.name}</Link>
        </Fragment>
      }
      else if (datas.type == 'GqWfABIpSearch_launch') {
        datas.typeContent = 'Antibody';
        datas.nameContent = <Fragment>
          <Link to={"/searchresantibody/template/" + encodeURIComponent(datas.name)} >{datas.name}</Link>
        </Fragment>
      }
      else if (datas.type == 'GqWfFTIpSearch_launch') {
        datas.typeContent = 'Fulltext Search';
        datas.nameContent = <Fragment>
          <Link to={"/ipseqsearch/template/" + encodeURIComponent(datas.name)} >{datas.name}</Link>
        </Fragment>
      }
      else if (datas.type == 'GqWfCmSearch_launch') {
        datas.typeContent = 'CM Search';
        const hasCmAccess = userInfo && userInfo.current_user && userInfo.current_user.cmAccess;
        datas.cmNoAccess = !hasCmAccess;
        datas.nameContent = hasCmAccess ? <Fragment>
          <Link to={"/cmsearch/template/" + encodeURIComponent(datas.name)} >{datas.name}</Link>
        </Fragment> : <Fragment>
          <span style={{color: '#bbb', fontStyle: 'italic'}}>{datas.name}</span>
        </Fragment>
      }
    });
  }
  async function routeToTemplateForm(e, tempObj) {
    e.preventDefault();
  }
  async function deleteTemplate() {
    const data = [];
    const dataValues = thing && thing.selectedRows && data.push(thing.selectedRows[0]);
    if (thing && thing.selectedCount >= 1 && data && data.length > 0) {
      // setSelectedTemplateData();
      setModalShow(true);
      // const result = await SavedSearch.deleteSavedTemplate(thing.selectedRows,thing.selectedCount);

      // toast.error("Under Construction!");
    }
    else {
      toast.error("Select Any One Item");
    }

  }
  function cancelForm() {
    history.push('/home');

  }
  function cancelForms() {
    setModalShow(false);
  }
  async function deleteForm() {
    const data = [];
    const dataValues = thing && thing.selectedRows && data.push(thing.selectedRows[0]);
    if (thing && thing.selectedCount >= 1 && data && data.length > 0) {
      const result = await SavedSearch.deleteSavedTemplate(thing.selectedRows, thing.selectedCount);
      getSavedTemplateData();
      setModalShow(false);
      setCheckValue(false);
      setThing([]);

    }
    else {
      toast.error("Select Any One Item");
    }
    // setModalShow(true); 
  }

  const selectableRowsComponentProps = {
    type: 'checkbox',
    style: {
      color: toggle ? 'grey' : 'rgb(174, 169, 169)',  // white when toggle is true, black when false
    },
};

  return (
    <div >
      <Row className={classes.columnPad} >
        <Col>
        {/* <div style={{ width: '100%', overflow: 'hidden', padding: '0', margin: '0' }}> */}
          <DataTable
            className='search-table'
            columns={columns}
            data={searchFormsData}
            defaultSortField="title"
            sortIcon={<SortIcon />}
            onSelectedRowsChange={updateVal}
            customStyles={toggle ? customStyles : customStylesDark}
            noHeader={true}
            noDataComponent='No items were found.'
            selectableRows
            selectableRowsComponent={Checkbox}
            selectableRowsComponentProps={selectableRowsComponentProps}
            conditionalRowStyles={[
              {
                when: row => row.cmNoAccess,
                style: {
                  color: '#bbb',
                  fontStyle: 'italic',
                },
              },
            ]}
          />
        {/* </div> */}
        </Col>
      </Row>
      <Row className="float-right">
        {/* <Col  className={classes.columnPadding}>
    <Button variant="contained" className={classes.buttonStyleCancel} onClick={homePage}>Cancel</Button>
     &nbsp;&nbsp;&nbsp;
    <Button color="primary" className='accountinfo' variant="contained" onClick={()=>deleteTemplate()} className="float-right loginSubmit text-capitalize" type="submit">Delete Selected Saved Search Forms</Button>   
  
      </Col> */}
        <div className={classes.footerDiv}>
          {searchFormsData && searchFormsData.length != 0 ?
            <Fragment>
              {checkValue && thing.selectedCount >= 1 ?
                <Button className='accountInfo' color="default" disableRipple={true} onClick={() => deleteTemplate()} variant="contained">Delete Selected Saved Search Forms</Button>
                : <Button className='cancelButtonDisable' color="default" disableRipple={true} variant="contained">Delete Selected Saved Search Forms</Button>

              }
              <Button className={classes.buttonStyleCancel} onClick={() => cancelForm()} disableRipple={true} color="default" variant="contained">Cancel</Button>
              <SavedSearchModal
                show={modalShow}
                onHide={() => cancelForms()}
                tryAgain={() => deleteForm()}
              // onMessage={errorMessage}
              />
            </Fragment>
            : <p></p>
          }
        </div>
      </Row>

    </div>

  );
}


export default SearchResults;
